$('.questions-t .qt[data-type=4]').each(function () {
	$(this).find('.letter').click(function () {
		if ($(this).hasClass('disabled'))
			return false;

		let letter = $(this).data('letter');
		let $qt = $(this).closest('.qt');

		let maxCount = parseInt($(this).attr('data-max-count'));
		let disable = maxCount === 1;

		if (disable) {
			$(this).addClass('disabled');
		}

		$(this).attr('data-max-count', maxCount - 1);

		let $input = $qt.find('.maker input').filter(function () {
			return !$(this).val();
		}).first();

		$input.val(letter);

		$qt.find('.maker .cleaner').show();

		Lection.cacheHomework();
	});

	$(this).find('.maker .cleaner').click(function () {
		let $qt = $(this).closest('.qt');

		$qt.find('.maker input').val('');
		$qt.find('.letters .letter').each(function (i, e) {
			$(e).removeClass('disabled');
			$(e).attr('data-max-count', $(e).attr('data-init-count'));
		});

		$(this).hide();

		Lection.cacheHomework();

		return false;
	});
});